import React from"react";
import WishlistButton from "./WishlistButton";
function Sports(){
    return <div className ="mencard">
    <div className="catalog-section-title"> <h1>Mens Casual Shoes</h1></div>
    <div className="row">
   
        <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Velocity IDP Running Shoes For Men  (White, Black).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Puma Velocity IDP Running Shoes For Men  (White, Black)</h6>
   <p></p>
   <h4> ₹1,549 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/evoSPEED 5.5 FG Football Shoes For Men  (Red, White, Black).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Puma evoSPEED 5.5 FG Football Shoes For Men  (Red, White, Black)</h6>
   <p></p>
   <h4> ₹3,351 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>


    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Rapido FG Football Shoes For Men  (White).jpeg"} alt="" />
   </div>
   <div className="card-header">
   <h6>Puma Rapido FG Football Shoes For Men  (White)</h6>
   <p></p>
   <h4> ₹2,099 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    
    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Seawalk IDP Running Shoes For Men  (Blue).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Puma Seawalk IDP Running Shoes For Men  (Blue)</h6>
   <p></p>
   <h4> ₹1,999 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Street Rush Lp Running Shoes For Men  (Navy).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Reebok Seawalk IDP Running Shoes For Men  (Blue)</h6>
   <p></p>
   <h4> ₹2,989 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>


    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/DRIFTIUM Running Shoes For Women  (Blue, White).jpeg"} alt="" />
   </div>
   <div className="card-header">
   <h6>Reebok DRIFTIUM Running Shoes For Women  (Blue, White)</h6>
   <p></p>
   <h4> ₹3,899 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>


    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Cool Traction Xtreme Lp Running Shoes For Men  (Grey).jpeg"} alt="" />
   </div>
   <div className="card-header">
   <h6>Reebok Cool Traction Xtreme Lp Running Shoes For Men  (Grey)</h6>
   <p></p>
   <h4> ₹1,614 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    
    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Ultra Speed V3 LP Running Shoes For Women  (Grey).jpeg"} alt="" />
   </div>
   <div className="card-header">
   <h6>Reebok Ultra Speed V3 LP Running Shoes For Women  (Grey)</h6>
   <p></p>
   <h4> ₹2,339 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Sneakers For Men  (White).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Woodland Sneakers For Men  (White)</h6>
   <p></p>
   <h4> ₹2,339 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Walking Shoes For Men  (Navy).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Woodland Walking Shoes For Men  (Navy)</h6>
   <p></p>
   <h4> ₹3,339 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Casuals For Men  (Multicolor).jpeg"} alt="" />
   </div>
   <div className="card-header">
   <h6>Woodland Casuals For Men  (Multicolor)</h6>
   <p></p>
   <h4> ₹3,140 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/Men Outdoor Shoes For Men  (Olive).jpeg"} alt="" />
   </div>
   <div className="card-header">
   <h6>Woodland Men Outdoor Shoes For Men  (Olive)</h6>
   <p></p>
   <h4> ₹2,845 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/OFF CUT Basketball Shoes For Men  (Black, White).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Fila OFF CUT Basketball Shoes For Men  (Black, White)</h6>
   <p></p>
   <h4> ₹2,219 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/IMPEDES Tennis Shoes For Men  (White).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Fila IMPEDES Tennis Shoes For Men  (White)</h6>
   <p></p>
   <h4> ₹1,979 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/ARDITO Running Shoes For Men  (Navy).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Fila ARDITO Running Shoes For Men  (Navy)</h6>
   <p></p>
   <h4> ₹1,399 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-3 col-md-6">
    <div className="card-body">
   <img className ="shoeimage"src={process.env.PUBLIC_URL + "/images/sportsimages/OFF CUT Basketball Shoes For Men  (Blue).jpeg"}alt=""  />
   </div>
   <div className="card-header">
   <h6>Fila OFF CUT Basketball Shoes For Men  (Blue)</h6>
   <p></p>
   <h4> ₹2,219 </h4>,
   <button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
   <p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>




    </div>
    </div>
}
export default Sports;